<template>
    <b-container fluid class="animated fadeIn">
        <h1>Exibir Comarca</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Nome:" label-for="nome" class="text-label">
                        <b-form-input 
                            id="nome"
                            name="nome"
                            v-model="comarca.nome" 
                            type="text" 
                            maxlength="150"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Nome Simplificado:" label-for="nomeSimplificado" class="text-label">
                        <b-form-input 
                            id="nomeSimplificado"
                            name="nomeSimplificado"
                            v-model="comarca.nomeSimplificado" 
                            type="text" 
                            maxlength="150"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Código TJ:" label-for="codigoTabelaTJ" class="text-label">
                        <b-form-input 
                            id="codigoTabelaTJ"
                            name="codigoTabelaTJ"
                            v-model="comarca.codigoTabelaTj" 
                            type="number"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Sigla:" label-for="sigla" class="text-label">
                        <b-form-input 
                            id="sigla"
                            name="sigla"
                            v-model="comarca.sigla" 
                            type="text" 
                            maxlength="12"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Última Remessa:" label-for="ultimoSeqRemessaH8" class="text-label">
                        <b-form-input 
                            id="ultimoSeqRemessaH8"
                            name="ultimoSeqRemessaH8"
                            v-model="comarca.ultimoSeqRemessaH8" 
                            type="number"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Município Sede Protesto:" label-for="municipioSedeProtesto" class="text-label">
                        <b-form-select
                            id="municipioSedeProtesto"
                            name="municipioSedeProtesto"
                            v-model="comarca.sedeProtesto"
                            :value="comarca.sedeProtesto"
                            :disabled="true">
                            <option 
                                v-for="municipio in dados.municipios" 
                                :key="municipio.codMunicipio"
                                :value="municipio">
                                {{ municipio.nome }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Município Sede Ajuizamento:" label-for="municipioSedeAjuizamento" class="text-label">
                        <b-form-select
                            id="municipioSedeAjuizamento"
                            name="municipioSedeAjuizamento"
                            v-model="comarca.sedeAjuizamento"
                            :value="comarca.sedeAjuizamento"
                            :disabled="true">
                            <option 
                                v-for="municipio in dados.municipios" 
                                :key="municipio.codMunicipio"
                                :value="municipio">
                                {{ municipio.nome }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="" label-for="homologadaCra" class="text-label">
                        <b-form-checkbox :disabled="true" v-model="comarca.homologadaCra" >Homologada na CRA</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        id="groupAtivo"
                        label="Situação: *"
                        label-for="ativo">
                        <b-form-checkbox :disabled="true" switch v-model="comarca.indAtivo">{{ comarca.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="8" sm="8" md="8" lg="8" xl="8">
                    <b-tabs content-class="mt-3" fill>
                        <b-tab title="Ajuizamento" active>
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <b-pagination v-model="configTableMunicipioAjuizamento.currentPage" :per-page="configTableMunicipioAjuizamento.perPage" :total-rows="configTableMunicipioAjuizamento.rows" size="sm" class="pl-3" style="float:right" v-if="configTableMunicipioAjuizamento.perPage != 'Todos'">
                                        </b-pagination>
                                        <b-form-select v-model="configTableMunicipioAjuizamento.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                    </div>
                                </b-col>
                            </b-row>
                            <TabelaMunicipio
                                :municipios="comarca.municipiosAjuizamento"
                                :fields="fieldsAjuizamento"
                                :configTable="configTableMunicipioAjuizamento" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <div>
                                            <b-pagination v-model="configTableMunicipioProtesto.currentPage" :per-page="configTableMunicipioProtesto.perPage" :total-rows="configTableMunicipioProtesto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableMunicipioProtesto.perPage != 'Todos'">
                                            </b-pagination>
                                            <b-form-select v-model="configTableMunicipioProtesto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Protesto">
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <b-pagination v-model="configTableMunicipioProtesto.currentPage" :per-page="configTableMunicipioProtesto.perPage" :total-rows="configTableMunicipioProtesto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableMunicipioProtesto.perPage != 'Todos'">
                                        </b-pagination>
                                        <b-form-select v-model="configTableMunicipioProtesto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                    </div>
                                </b-col>
                            </b-row>
                            <TabelaMunicipio
                                :municipios="comarca.municipiosProtesto"
                                :fields="fieldsProtesto"
                                :configTable="configTableMunicipioProtesto" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <b-pagination v-model="configTableMunicipioProtesto.currentPage" :per-page="configTableMunicipioProtesto.perPage" :total-rows="configTableMunicipioProtesto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableMunicipioProtesto.perPage != 'Todos'">
                                        </b-pagination>
                                        <b-form-select v-model="configTableMunicipioProtesto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" @click="voltar">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import TabelaMunicipio from './TabelaMunicipio'
import formatarMixins from '../../../mixins/formatarMixins'

export default {
    name: 'ManterComarcaEditar',
    mixins: [ formatarMixins ],
    components: {
        TabelaMunicipio
    },
    data() {
        return {
            comarca: {
                nome: null,
                sigla: null,
                nomeSimplificado: null,
                codigoTabelaTj: null,
                ultimoSeqRemessaH8: null,
                sedeProtesto: null,
                sedeAjuizamento: null,
                homologadaCra: false,
                indAtivo: true,
                municipiosAjuizamento: [],
                municipiosProtesto: []
            },
            dados: {
                municipios: []
            },
            configTableMunicipioAjuizamento: {
                perPage: 100,
                currentPage: 1,
                rows: 0,
            },
            configTableMunicipioProtesto: {
                perPage: 100,
                currentPage: 1,
                rows: 0,
            },
            fieldsAjuizamento: [
                {
                    key: 'nome',
                    label: 'Município de Ajuizamento'
                },
                {
                    key: 'dataInclusao',
                    label: 'Data Inclusão',
                    class: 'text-center'
                },
            ],
            fieldsProtesto: [
                {
                    key: 'nome',
                    label: 'Município de Protesto'
                },
                {
                    key: 'dataInclusao',
                    label: 'Data Inclusão',
                    class: 'text-center'
                },
            ]
        }
    },
    methods: {


        voltar() {
            this.$store.commit("setComarca", null);
            this.$router.push({ path: '/comarca' })
        },

        /**
         * Listar municípios
         */
        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listar`)
            .then(response => {
              this.dados.municipios = response.data
            })
        },

        async obterComarca(codComarca) {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token

            await axios.post(`${urlApi}/v1/comarca/obter`, codComarca, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.comarca = response.data
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const comarcaEditada = this.$store.getters.getComarca;
        if(comarcaEditada) {
            this.obterComarca(comarcaEditada.codComarca)
        }

        this.listarMunicipios()

    }
    
}
</script>

<style scoped>


</style>